import { APP_API } from "@/src/const";
import { Log } from "@/src/util/log";

export type FlowFrontendServiceType<T> = {
  success: boolean;
  status: number;
  response?: T;
  error?: any;
};

export async function http<T>(
  method: "GET" | "PUT" | "POST" | "PATCH",
  pathname: string,
  queryParams?: string,
  payload?: any
): Promise<FlowFrontendServiceType<T>> {
  const url = `${APP_API}/api${pathname}${queryParams ? `?${queryParams}` : ""}`;

  const returnResponse = (
    toResolve: FlowFrontendServiceType<T>,
    resolve: (value: FlowFrontendServiceType<T> | PromiseLike<FlowFrontendServiceType<T>>) => void
  ) => {
    Log.logToConsoleDebug("FlowFrontendService.ts:(http)", "FLOW FRONTEND API REQUEST", [url, "GET", toResolve]);

    if (!toResolve.success && toResolve.status !== 404) {
      Log.logToProvider(Log.LogLevel.ERROR, "FlowFrontendServiceType.ts", "API REQUEST ERROR", [url, "GET", toResolve]);
    }

    resolve(toResolve);
  };

  return await new Promise(async (resolve) => {
    fetch(url, {
      method,
      body: payload ? JSON.stringify(payload) : undefined,
    })
      .then((response) => {
        const { status } = response;
        switch (status) {
          case 200:
            response.json().then((response) => {
              returnResponse({ success: true, status, response }, resolve);
              return;
            });
            return;
          default:
            response.text().then((response) => {
              returnResponse({ success: false, status, error: response }, resolve);
            });
            return;
        }
      })
      .catch((error) => {
        returnResponse({ success: false, status: 500, error: error.toString() }, resolve);
      });
  });
}
